export default import.meta.ROLLDOWN_FILE_URL_hgR0VPKeoxf8ccJWimbDxw